<div class="vertailu-lohko">
  <div class="vertailu-otsikkorivi">
    <strong>v{{ vertailu.valittu.versio }}</strong>
    <span class="vertailu-harmaa">{{ vertailu.valittu.paivitetty | date: 'dd.MM.yyyy HH:mm' }}</span>
    <span class="vertailu-tayte"></span>
    <app-button (click)="palauta.emit(vertailu.valittu.versio)" actionId="Palauta esikatseltu promptversio">Palauta tämä versio</app-button>
    <app-icon-button (click)="sulje.emit()" matIcon="close" actionId="Sulje promptversion esikatselu"></app-icon-button>
  </div>

  <div class="vertailu-valintarivi">
    <span class="vertailu-harmaa">Vertaa:</span>
    <mat-radio-group [value]="vertailukohta" (change)="asetaVertailukohta($event.value)">
      <mat-radio-button value="edellinen">Edelliseen versioon</mat-radio-button>
      <mat-radio-button value="aktiivinen" [disabled]="!vertailu.aktiivinen">Aktiiviseen versioon</mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="vertailu-tila">
    @if (vertailuversio; as vv) {
      Verrattu versioon v{{ vv.versio }}
      @if (!onMuutoksia) {
        — ei muutoksia promptitekstissä
      }
    } @else {
      Ensimmäinen versio, ei vertailukohtaa
    }
  </div>

  @if (vertailu.valittu.nimi !== undefined) {
    <div class="vertailu-lisatieto">
      Nimi:
      @if (nimiMuuttui) {
        <span class="diff-poistettu">{{ vertailuversio?.nimi }}</span> → <span class="diff-lisatty">{{ vertailu.valittu.nimi }}</span>
      } @else {
        <strong>{{ vertailu.valittu.nimi }}</strong>
      }
    </div>
  }

  @if (vertailu.valittu.tilikarttaRajat) {
    <div class="vertailu-lisatieto">
      Tilisarjat:
      @for (muutos of tilisarjojenMuutokset; track $index) {
        <span [class]="'tilisarja diff-' + muutos.tyyppi">{{ muutos.raja.alkaa }}–{{ muutos.raja.loppuu }}</span>
      }
      @if (!vertailu.valittu.tilikarttaRajat.length) {
        <span class="vertailu-harmaa">Koko tilikartta</span>
      }
    </div>
  }

  <pre class="vertailu-sisalto">@for (muutos of muutokset; track $index) {<span [class]="'diff-' + muutos.tyyppi">{{ muutos.teksti }}</span>}</pre>

  <div class="vertailu-selite"><span class="diff-lisatty">Lisätty</span> <span class="diff-poistettu">Poistettu</span></div>
</div>
